import { atom } from 'jotai'

import type { PurchasableDay } from '../_hooks/use-app-experience-purchasable-days'

export type TicketDialog = 'sheet' | 'tickets' | 'date' | null

export const ticketDialogAtom = atom<TicketDialog>(null)

export const selectedTicketDayAtom = atom<PurchasableDay | null>(null)
